import {
  CalendarTasksGroup,
  CommonUtils,
  Time,
} from '@infodata-group/inf-commons';
import dayjs, { Dayjs } from 'dayjs';

export class AgendaDetailedSubCell {
  public date: Dayjs;
  public timeStart: Time;
  public timeEnd: Time;
  public height = 30;
  public resource: CalendarTasksGroup;

  public isOff = false;
  public isTeleworked = false;
  public isHovered = false;
  public isSelected = false;

  constructor(
    timeStart: Time,
    timeEnd: Time,
    resource: CalendarTasksGroup,
    date: Date,
    height?: number,
  ) {
    this.timeStart = timeStart;
    this.timeEnd = timeEnd;
    this.resource = resource;
    this.date = dayjs(date);
    if (height) {
      this.height = height;
    }
  }

  get backgroundColor(): string {
    if (this.isSelected) {
      return 'var(--cell-selected-color)';
    }
    if (this.isHovered) {
      return 'var(--cell-hover-color)';
    }
    if (this.isOff) {
      return 'var(--day-not-work-color)';
    }
    if (this.isTeleworked) {
      return 'var(--telework-color)';
    }
    return CommonUtils.color('white');
  }
}
